if ("undefined" === typeof NHS || null === NHS) { NHS = {}; }
NHS.loadJs = function (jsPathName, id, callback, isAsync) {
    var scriptTag = document.querySelector('script[src="' + jsPathName + '"]');
    if (scriptTag) {

      // execute the callback since the code already exists
      callback();
      return;
    }
    scriptTag = document.createElement("script");
    scriptTag.src = jsPathName;
    scriptTag.id = id;
    scriptTag.type = 'text/javascript';
    scriptTag.async = !!isAsync;
    document.documentElement.appendChild(scriptTag);
    if (typeof callback === "function") {
        scriptTag.addEventListener("load", callback);
    }
};